import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import axios from "connection";
import { redirectToID } from "state/config-slice";

const useAxiosInterceptor = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    // Generate a Transaction ID for a session
    let transactionId: string = sessionStorage.getItem("Transaction-Id") || "";
    if (!transactionId) {
      transactionId = uuidv4();
      sessionStorage.setItem("Transaction-Id", transactionId);
    }

    // Request interceptor to add Transaction ID
    const requestInterceptor = axios.interceptors.request.use(
      (config) => {
        config.headers["Transaction-Id"] = transactionId;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );

    const interceptor = axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        const status = error?.response?.status;

        if (status === 401) {
          dispatch(redirectToID(null));
        }

        if (status === 500) {
          navigate("/error");
        }

        return Promise.reject(error);
      },
    );

    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(interceptor);
    };
  }, [dispatch, navigate]);

  return null;
};

export default useAxiosInterceptor;
